import * as _ht from './_ht';
import * as _hm from './_hf';
import * as _hmDTM from './_hfDTM';

import * as ihv from './ihv';

export const cvtGenmenflgNbrToSrg = (genmenflg: _ht.n) => {
  switch(_hm.n(genmenflg)) {
    case 1:
      return '10割'
    case 2:
      return '5割'
    case 3:
      return 'その他'
    case 0:
      return 'なし'
    default:
      return '規定外'
  }
}

export const cvtYflgNbrToSrg = (yflg: _ht.n) => {
  switch(_hm.n(yflg)) {
    case 1:
      return '仮予約'
    case 2:
      return '予約'
    case 3:
      return '予約不可'
    case 4:
      return '個人利用'
    case 5:
      return '老福利用'
    case 0:
      return 'キャンセル(返金なし)'
    case -1:
      return 'キャンセル(返金あり)'
    case -2:
      return '削除'
    default:
      return '規定外'
  }
}

export const getLtyPrds = (pz: { // 抽選対象月を取得する、抽選実施月でない場合は返さない
  dtm: _ht.s
  i19rz: _ht.dz, 
//  S91010112: _ht.s,
}) => { // 抽選対象期間の取得
  //_hm.l(`ihm 10: ${pz.i19rz.i19ra4100i}`)
  if (pz.i19rz.i19ra4100i == 3) { // 抽選間隔が３ヶ月の場合
    const _ltyMths = // 抽選実施月
      pz.i19rz.i19ra4200i == 1 ? // 抽選基準月が1月 -> エントリーが1月で抽選は2月（対象月は4/5/6月）
        //[1,4,7,10]
        [2,5,8,11]
      : pz.i19rz.i19ra4200i == 2 ? // 抽選基準月が2月 -> エントリーが2月で抽選は3月（対象月は5/6/7月）
        //[2,5,8,11]
        [3,6,9,12]
      : pz.i19rz.i19ra4200i == 3 ? // 抽選基準月が3月 -> エントリーが3月で抽選は4月（対象月は5/6/7月）
        //[3,6,9,12]
        [4,7,10,1]
      : undefined;
    //_hm.l(`ihm 20: ${pz.i19rz.i19ra4200i}, ${_hm.s(_ltyMths)}`)
    if (_ltyMths && _hm.i(_hmDTM.cvtMth(pz.dtm), _ltyMths)) { // 抽選実施月の場合
      //_hm.l(`ihm 22: ${_hmDTM.cvtMth(pz.dtm)}`)
      const _ltyPrds = _hm.getRng(3,1).map((_cnt: _ht.n) => { // 
        return _hmDTM.addMth(_hmDTM.cvtFdm(pz.dtm), 3 - 1 + _cnt - 1) // 基準月翌月に抽選を行うため -1
      });
      //_hm.l(`ihm 26: ${_hm.s(_ltyPrds)}`)
      return _ltyPrds;
    }
    else { // 抽選対象月でない場合
      //_hm.l(`ihm 30: here`)
      return undefined;
    }
  }
  else { // 抽選間隔が1ヶ月の場合
    const _ltyPrds = [_hmDTM.addMth(_hmDTM.cvtFdm(pz.dtm), 2)];
    //_hm.l(`ihm 36: ${_hm.s(_ltyPrds)}`)
    return _ltyPrds
  }
};

export const getDayCtg = (pz: {
  // 日祝・土曜・平日の取得
  date: _ht.s,
  _601s: _ht.ls,
}) => {
  const _dow = _hmDTM.cvtDow(pz.date);
  //hf.l(`icm 130: ${pz.date}, ${_dow}`);
  if (_dow == "日" || _hm.i(pz.date, pz._601s)) return "日祝";
  if (_dow == "土") return "土曜";
  return "平日";
};

export const getI101z = (pz: {
  i1z1d1100s: _ht.s,
  i1z1i1111f: _ht.n,
  i101s: _ht.ls,
}) => {
  let _i101z = {}
  if (pz.i1z1i1111f != ihv.otrz._fst) { // その他１時間以外
    pz.i101s?.map((_i101z2: _ht.dz) => {
      if (
        pz.i1z1d1100s >= _i101z2.i101d1110s &&
        pz.i1z1d1100s <= _i101z2.i101d1120s
      ) { // 適用開始日以降適用開始日以前の場合
        _i101z = _i101z2
      }
      //_hm.l(`ihm 101: ${pz.i1z1i1111f}, ${pz.i1z1d1100s}, ${_i101z2.i101d1110s}, ${_i101z2.i101d1120s}, ${_hm.s(_i101z)}`)
    })
  }
  return _i101z
}

export const getFee = (pz: {
  // 利用料の取得
  i1zrd3100s: _ht.s; // date
  i10ra2100i?: _ht.n; // 延長料の取得元
  i111_fst: _ht.n; // その他１時間の特定に必要
  i11ra1100i: _ht.n; // 夏時間の特定に必要
  i11ra1200i: _ht.n; // 夏時間の特定に必要
  i101z: _ht.dz; // 利用料の取得元
  i15ra6100i?: _ht.n; // １種・２種の特定に必要
  _601s: _ht.ls, // 祝日
}) => {
  if (pz.i111_fst == ihv.otrz._fst) { // その他１時間
    return pz.i10ra2100i;
  }

  const _zoneCtg = pz.i15ra6100i ?? 1;
  const _mthCtg = getMthCtg({
    date: pz.i1zrd3100s,
    i11ra1100i: pz.i11ra1100i,
    i11ra1200i: pz.i11ra1200i,
  });
  const _dayCtg = getDayCtg({
    date: pz.i1zrd3100s,
    _601s: pz._601s,
  });

  //_hm.l(`ihm 250a1: ${_zoneCtg}, ${_mthCtg}, ${_dayCtg}`);
  //_hm.l(`ihm 250a2: ${_hm.s(pz.i101z)}`);

  if (_zoneCtg == 2) {
    // 2種
    if (_mthCtg == "夏時間") {
      // 夏時間
      if (_dayCtg == "日祝") {
        // 日曜
        //_hm.l(`ihm 250b: ${_zoneCtg}, ${_mthCtg}, ${_dayCtg}`);
        return pz.i101z?.i101a1223i;
      } else if (_dayCtg == "土曜") {
        // 土曜
        //_hm.l(`ihm 250c: ${_zoneCtg}, ${_mthCtg}, ${_dayCtg}`);
        return pz.i101z?.i101a1222i;
      } else {
        // 平日
        //_hm.l(`ihm 250d: ${_zoneCtg}, ${_mthCtg}, ${_dayCtg}`);
        return pz.i101z?.i101a1221i;
      }
    } else {
      // 通常
      if (_dayCtg == "日祝") {
        // 日曜
        //_hm.l(`ihm 250e: ${_zoneCtg}, ${_mthCtg}, ${_dayCtg}`);
        return pz.i101z?.i101a1213i;
      } else if (_dayCtg == "土曜") {
        // 土曜
        //_hm.l(`ihm 250f: ${_zoneCtg}, ${_mthCtg}, ${_dayCtg}`);
        return pz.i101z?.i101a1212i;
      } else {
        // 平日
        //_hm.l(`ihm 250g: ${_zoneCtg}, ${_mthCtg}, ${_dayCtg}`);
        return pz.i101z?.i101a1211i;
      }
    }
  } else {
    // 1種
    if (_mthCtg == "夏時間") {
      // 夏時間
      if (_dayCtg == "日祝") {
        // 日曜
        //_hm.l(`ihm 250h: ${_zoneCtg}, ${_mthCtg}, ${_dayCtg}`);
        return pz.i101z?.i101a1123i;
      } else if (_dayCtg == "土曜") {
        // 土曜
        //_hm.l(`ihm 250i: ${_zoneCtg}, ${_mthCtg}, ${_dayCtg}`);
        return pz.i101z?.i101a1122i;
      } else {
        // 平日
        //_hm.l(`ihm 250j: ${_zoneCtg}, ${_mthCtg}, ${_dayCtg}`);
        return pz.i101z?.i101a1121i;
      }
    } else {
      // 通常
      if (_dayCtg == "日祝") {
        // 日曜
        //_hm.l(`ihm 250k: ${_zoneCtg}, ${_mthCtg}, ${_dayCtg}`);
        return pz.i101z?.i101a1113i;
      } else if (_dayCtg == "土曜") {
        // 土曜
        //_hm.l(`ihm 250l: ${_zoneCtg}, ${_mthCtg}, ${_dayCtg}`);
        return pz.i101z?.i101a1112i;
      } else {
        // 平日
        //_hm.l(`ihm 250m: ${_zoneCtg}, ${_mthCtg}, ${_dayCtg}`);
        return pz.i101z?.i101a1111i;
      }
    }
  }
};

export const getMthCtg = (pz: {
  // 夏時間の取得
  date: _ht.s;
  i11ra1100i: _ht.n;
  i11ra1200i: _ht.n;
}) => {
  const _nMth = _hmDTM.cvtMth(pz.date);
  if (_nMth >= pz.i11ra1100i && _nMth <= pz.i11ra1200i) return "夏時間";
  return "通常";
};

/**
 * @function
 * @description 抽選間隔・抽選基準月・現在日を元に、エントリー状況または予約状況の更新期間を返す
 * @param i19ra4100i 抽選間隔
 * @param i19ra4200i 抽選基準月（抽選間隔が3ヶ月の場合のみ）
 * @param tgt 取得対象 e: entry, r: reserver
 * @param date 現在日
 * @return エントリー状況または予約状況の対象期間
*/
export const getUstPrdI1z5 = (pz: {
  i19ra4100i: _ht.n,
  i19ra4200i?: _ht.n,
  tgt: 'e' | 'r',
  date: _ht.s,
}): _ht.ls => {

  if (pz.i19ra4100i == 3) { // 抽選間隔が3ヶ月ごとの場合

    const _thisMth = _hmDTM.cvtMth(pz.date);
    const _thisEryPrdSttMth = _hm.cvtFlr((_thisMth - (pz.i19ra4200i ?? 1)) / 3) * 3 + (pz.i19ra4200i ?? 1);
    const _nextEryPrdSttMth = _thisEryPrdSttMth + 3;
    const _nextEryPrdEndMth = _nextEryPrdSttMth + (3 - 1);
    const _endMth = _nextEryPrdEndMth;

    let _sttMth = _thisMth; // 予約状況の場合
    if (pz.tgt == 'e') { // エントリー状況の場合
      _sttMth = _nextEryPrdSttMth;
    }

    const _mths = _hm.getRng(_endMth - _thisMth, _sttMth - _thisMth).map((_cnt: _ht.n) => _hmDTM.addMth(_hmDTM.cvtFdm(pz.date), _cnt));
    return _mths;

  }
  else { // 抽選間隔が1ヶ月ごとの場合

    const _thisMth = _hmDTM.cvtMth(pz.date);
    const _endMth = _thisMth + 2;

    let _sttMth = _thisMth; // 予約状況の場合
    if (pz.tgt == 'e') { // エントリー状況の場合
      _sttMth = _thisMth + 2;
    }

    const _mths = _hm.getRng(_endMth - _thisMth, _sttMth - _thisMth).map((_cnt: _ht.n) => _hmDTM.addMth(_hmDTM.cvtFdm(pz.date), _cnt));
    return _mths;

  }

};

/**
 * @function
 * @description 指定された部屋・日・時間帯のエントリー状況および予約状況を追加・更新するクエリを生成する
 * @remarks サーバーサイドとクライアントサイドでロジックを共通化するため、ihm 上に実装
 * @param _dmn クライアント
 * @param i1z5_31r1f 施設
 * @param i1z5i10r1f 部屋
 * @param i1z5d1100s 日
 * @param i1z5i1111f 時間帯
 * @return エントリー状況・予約状況を更新するクエリのリスト
*/
/*
export const grtQryUstCntI1z5 = (pz: {
  _dmn: _ht.n,
  i1z5_31r1f: _ht.n,
  i1z5i10r1f: _ht.n,
  i1z5d1100s: _ht.s,
  i1z5i1111f: _ht.n,
}) => {
  return [
    {
      qry: ` -- 集計対象行の追加
        INSERT INTO
          i1z5s
        (
          _dmn,
          i1z5_31r1f,
          i1z5i10r1f,
          i1z5d1100s,
          i1z5i1111f,
          "createdAt",
          "updatedAt"
        )
        VALUES (
          ${pz._dmn},
          ${pz.i1z5_31r1f},
          ${pz.i1z5i10r1f},
          '${pz.i1z5d1100s}',
          ${pz.i1z5i1111f},
          now(),
          now()
        )
        ON CONFLICT ON CONSTRAINT i1z5_unq1
        DO NOTHING
      `
    },
    {
      // 夏時間開始月・終了月の設定（追加したもののみ）
      qry: `
        UPDATE
          i1z5s
        SET
          (i1z5d2100i, i1z5d2200i) = (
            SELECT
              COALESCE(i11ra1100i,0), COALESCE(i11ra1200i,0)
            FROM
              i111s LEFT JOIN i11rs ON i111s.i111i11r1k = i11rs._key
            WHERE
              COALESCE(i111s._dlt,-1)<>1
              AND i111s.i111_31r1f = i1z5s.i1z5_31r1f
              AND i111s._fst = i1z5s.i1z5i1111f
              AND COALESCE(i11rs._dlt,-1)<>1
              AND i11rs._vsn = i11rs._ltt
              AND i11rs.i11r_31r1f = i1z5s.i1z5_31r1f
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s = '${pz.i1z5d1100s}'
          AND i1z5s.i1z5i1111f = ${pz.i1z5i1111f}
      `,
    },
    {
      // 夏区分の設定（追加したもののみ）
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5c1100i = (
            SELECT
              CASE
                WHEN
                  SUBSTRING(i1z5d1100s, 6, 2)::NUMERIC >= i1z5d2100i
                  AND SUBSTRING(i1z5d1100s, 6, 2)::NUMERIC <= i1z5d2200i
                THEN
                  1
                ELSE
                  -1
              END
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s = '${pz.i1z5d1100s}'
          AND i1z5s.i1z5i1111f = ${pz.i1z5i1111f}
      `,
    },
    {
      // 曜日の設定　＃祝日区分（追加したもののみ）
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5c2100i = (
            SELECT
              CASE
                WHEN
                  EXISTS(
                    SELECT
                      *
                    FROM
                      _601s
                    WHERE
                      COALESCE(_601s._dlt,-1)<>1
                      AND _601s._icn = i1z5s.i1z5d1100s
                  )
                THEN
                  1
                ELSE
                  -1
              END
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s = '${pz.i1z5d1100s}'
          AND i1z5s.i1z5i1111f = ${pz.i1z5i1111f}
      `,
    },
    {
      // 曜日の設定　＃曜日区分（追加したもののみ）
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5c3100i = (
            SELECT
              CASE
                WHEN
                  i1z5c2100i = 1 OR DATE_PART('dow', i1z5d1100s::TIMESTAMP)::NUMERIC = 0
                THEN
                  30
                WHEN
                  DATE_PART('dow', i1z5d1100s::TIMESTAMP)::NUMERIC = 6
                THEN
                  20
                ELSE
                  10
              END
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s = '${pz.i1z5d1100s}'
          AND i1z5s.i1z5i1111f = ${pz.i1z5i1111f}
      `,
    },
    {
      // 開始・終了時刻の設定
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5d3100i = (
            SELECT
              CASE
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 10
                THEN
                  i111a1111i
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 20
                THEN
                  i111a1112i
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 30
                THEN
                  i111a1113i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 10
                THEN
                  i111a1121i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 20
                THEN
                  i111a1122i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 30
                THEN
                  i111a1123i
                ELSE
                  0
              END
            FROM
              i111s
            WHERE
              COALESCE(i111s._dlt,-1)<>1
              AND i111s._vsn = i111s._ltt
              AND i111s.i111_31r1f = i1z5s.i1z5_31r1f
              AND i111s._fst = i1z5s.i1z5i1111f
          ),
          i1z5d3200i = (
            SELECT
              CASE
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 10
                THEN
                  i111a2111i
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 20
                THEN
                  i111a2112i
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 30
                THEN
                  i111a2113i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 10
                THEN
                  i111a2121i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 20
                THEN
                  i111a2122i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 30
                THEN
                  i111a2123i
                ELSE
                  0
              END
            FROM
              i111s
            WHERE
              COALESCE(i111s._dlt,-1)<>1
              AND i111s._vsn = i111s._ltt
              AND i111s.i111_31r1f = i1z5s.i1z5_31r1f
              AND i111s._fst = i1z5s.i1z5i1111f
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s = '${pz.i1z5d1100s}'
          AND i1z5s.i1z5i1111f = ${pz.i1z5i1111f}
      `,
    },
    {
      // 予約数の更新
      // 集計対象：指定された単体部屋＋指定された複合部屋＋指定された単体部屋を含む複合部屋＋指定された複合部屋に属する単体部屋
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5a1100i = (
            SELECT
              COUNT(*)
            FROM
              i1z1s
              LEFT JOIN i1zrs ON i1z1s.i1z1i1zr1k = i1zrs._key
            WHERE
              COALESCE(i1zrs._dlt,-1) <> 1 AND i1zrs._vsn = i1zrs._ltt
              AND i1zrs.i1zr_31r1f = i1z5s.i1z5_31r1f
              AND i1zrs.i1zrd3100s = i1z5s.i1z5d1100s
              AND i1zrs.i1zrs1100i >= 70
              AND COALESCE(i1z1s._dlt,-1) <> 1
              AND i1z1s.i1z1_31r1f = i1zrs.i1zr_31r1f
              AND (
                (i1z1s.i1z1i10r1f = i1z5s.i1z5i10r1f)
                OR i1z1s.i1z1i10r1f IN (
                  SELECT 
                    _fst 
                  FROM 
                    i10rs 
                  WHERE
                    COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i10r_31r1f = i1z5s.i1z5_31r1f
                    AND _key IN (
                      SELECT
                        i102i10r1k
                      FROM
                        i102s
                      WHERE
                        COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i102_31r1f = i1z5s.i1z5_31r1f
                        AND i102i10r1f = i1z5s.i1z5i10r1f
                    )
                )
                OR i1z1s.i1z1i10r1f IN (
                  SELECT
                    i102i10r1f
                  FROM
                    i102s
                  WHERE
                    COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i102_31r1f = i1z5s.i1z5_31r1f
                    AND i102i10r1k IN (
                      SELECT
                        _key
                      FROM
                        i10rs
                      WHERE
                        COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i10r_31r1f = i1z5s.i1z5_31r1f
                        AND _fst = i1z5s.i1z5i10r1f
                    )
                )
              )
              AND i1z1s.i1z1a1200i > i1z5s.i1z5d3100i
              AND i1z1s.i1z1a1100i < i1z5s.i1z5d3200i
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s = '${pz.i1z5d1100s}'
          AND i1z5s.i1z5i1111f = ${pz.i1z5i1111f}
      `,
    },
    {
      // エントリ数の更新（予約数が更新されている前提）
      // 集計対象：指定された単体部屋＋指定された複合部屋＋指定された単体部屋を含む複合部屋
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5a2100i = (
            SELECT
              COUNT(*)
            FROM
              i1z1s LEFT JOIN i1zrs ON i1z1s.i1z1i1zr1k = i1zrs._key
            WHERE
              COALESCE(i1zrs._dlt,-1)<>1
              AND i1zrs._vsn = i1zrs._ltt
              AND i1zrs.i1zr_31r1f = i1z5s.i1z5_31r1f
              AND i1zrs.i1zrd3100s = i1z5s.i1z5d1100s
              AND i1zrs.i1zrs1200i >= 70
              AND COALESCE(i1z1s._dlt,-1)<>1
              AND i1z1s.i1z1_31r1f = i1zrs.i1zr_31r1f
              AND (
                (i1z1s.i1z1i10r1f = i1z5s.i1z5i10r1f)
                OR i1z1s.i1z1i10r1f IN (
                  SELECT 
                    _fst 
                  FROM 
                    i10rs 
                  WHERE
                    COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i10r_31r1f = i1z5s.i1z5_31r1f
                    AND _key IN (
                      SELECT
                        i102i10r1k
                      FROM
                        i102s
                      WHERE
                        COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i102_31r1f = i1z5s.i1z5_31r1f
                        AND i102i10r1f = i1z5s.i1z5i10r1f
                    )
                )
                OR i1z1s.i1z1i10r1f IN (
                  SELECT
                    i102i10r1f
                  FROM
                    i102s
                  WHERE
                    COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i102_31r1f = i1z5s.i1z5_31r1f
                    AND i102i10r1k IN (
                      SELECT
                        _key
                      FROM
                        i10rs
                      WHERE
                        COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i10r_31r1f = i1z5s.i1z5_31r1f
                        AND _fst = i1z5s.i1z5i10r1f
                    )
                )
              )
              AND i1z1s.i1z1a1200i > i1z5s.i1z5d3100i
              AND i1z1s.i1z1a1100i < i1z5s.i1z5d3200i
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s = '${pz.i1z5d1100s}'
          AND i1z5s.i1z5i1111f = ${pz.i1z5i1111f}
      `,
    },
  ]
};
*/
/*
export const grtQrySctCntI1z5 = (pz: {
  _dmn: _ht.n,
  i1z5_31r1f: _ht.n,
  i1z5i10r1f: _ht.n,
  i1z5d1100s: _ht.s,
  i1z5i1111f: _ht.n,
}) => {
  return [
    {
      qry: `
        SELECT
          *
        FROM
          i1z5s
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s = '${pz.i1z5d1100s}'
          AND i1z5s.i1z5i1111f = ${pz.i1z5i1111f}
       `
    },
  ]
};
*/
export const grtQrySctCntI1z5 = (pz: {
  _dmn: _ht.n,
  i1z5_31r1f: _ht.n,
  i1z5i10r1f: _ht.n,
  i1z5d1100sStt: _ht.s,
  i1z5d1100sEnd: _ht.s,
}) => {
  return [
    {
      qry: `
        SELECT
          *
        FROM
          i1z5s
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s >= '${pz.i1z5d1100sStt}'
          AND i1z5s.i1z5d1100s <= '${pz.i1z5d1100sEnd}'
       `
    },
  ]
};

export const grtQryIstCntI1z5 = (pz: {
  _dmn: _ht.n,
  i1z5_31r1f: _ht.n,
  i1z5i10r1f: _ht.n,
  i1z5d1100s: _ht.s,
  i1z5i1111f: _ht.n,
}) => {
  return [
    {
      qry: `
        INSERT INTO
          i1z5s
        (
          _dmn,
          i1z5_31r1f,
          i1z5i10r1f,
          i1z5d1100s,
          i1z5i1111f,
          "createdAt",
          "updatedAt"
        )
        VALUES (
          ${pz._dmn},
          ${pz.i1z5_31r1f},
          ${pz.i1z5i10r1f},
          '${pz.i1z5d1100s}',
          ${pz.i1z5i1111f},
          now(),
          now()
        )
        -- 事前チェックがあるため、重複実行されない限り、制約違反は発生しない前提
        -- ON CONFLICT ON CONSTRAINT i1z5_unq1
        -- DO NOTHING
      `
    },
/*
    {
      // 夏時間開始月・終了月の設定（追加したもののみ）
      qry: `
        UPDATE
          i1z5s
        SET
          (i1z5d2100i, i1z5d2200i) = (
            SELECT
              COALESCE(i11ra1100i,0), COALESCE(i11ra1200i,0)
            FROM
              i111s LEFT JOIN i11rs ON i111s.i111i11r1k = i11rs._key
            WHERE
              COALESCE(i111s._dlt,-1)<>1
              AND i111s.i111_31r1f = i1z5s.i1z5_31r1f
              AND i111s._fst = i1z5s.i1z5i1111f
              AND COALESCE(i11rs._dlt,-1)<>1
              AND i11rs._vsn = i11rs._ltt
              AND i11rs.i11r_31r1f = i1z5s.i1z5_31r1f
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s = '${pz.i1z5d1100s}'
          AND i1z5s.i1z5i1111f = ${pz.i1z5i1111f}
      `,
    },
    {
      // 夏区分の設定（追加したもののみ）
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5c1100i = (
            SELECT
              CASE
                WHEN
                  SUBSTRING(i1z5d1100s, 6, 2)::NUMERIC >= i1z5d2100i
                  AND SUBSTRING(i1z5d1100s, 6, 2)::NUMERIC <= i1z5d2200i
                THEN
                  1
                ELSE
                  -1
              END
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s = '${pz.i1z5d1100s}'
          AND i1z5s.i1z5i1111f = ${pz.i1z5i1111f}
      `,
    },
    {
      // 曜日の設定　＃祝日区分（追加したもののみ）
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5c2100i = (
            SELECT
              CASE
                WHEN
                  EXISTS(
                    SELECT
                      *
                    FROM
                      _601s
                    WHERE
                      COALESCE(_601s._dlt,-1)<>1
                      AND _601s._icn = i1z5s.i1z5d1100s
                  )
                THEN
                  1
                ELSE
                  -1
              END
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s = '${pz.i1z5d1100s}'
          AND i1z5s.i1z5i1111f = ${pz.i1z5i1111f}
      `,
    },
    {
      // 曜日の設定　＃曜日区分（追加したもののみ）
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5c3100i = (
            SELECT
              CASE
                WHEN
                  i1z5c2100i = 1 OR DATE_PART('dow', i1z5d1100s::TIMESTAMP)::NUMERIC = 0
                THEN
                  30
                WHEN
                  DATE_PART('dow', i1z5d1100s::TIMESTAMP)::NUMERIC = 6
                THEN
                  20
                ELSE
                  10
              END
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s = '${pz.i1z5d1100s}'
          AND i1z5s.i1z5i1111f = ${pz.i1z5i1111f}
      `,
    },
    {
      // 開始・終了時刻の設定
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5d3100i = (
            SELECT
              CASE
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 10
                THEN
                  i111a1111i
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 20
                THEN
                  i111a1112i
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 30
                THEN
                  i111a1113i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 10
                THEN
                  i111a1121i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 20
                THEN
                  i111a1122i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 30
                THEN
                  i111a1123i
                ELSE
                  0
              END
            FROM
              i111s
            WHERE
              COALESCE(i111s._dlt,-1)<>1
              AND i111s._vsn = i111s._ltt
              AND i111s.i111_31r1f = i1z5s.i1z5_31r1f
              AND i111s._fst = i1z5s.i1z5i1111f
          ),
          i1z5d3200i = (
            SELECT
              CASE
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 10
                THEN
                  i111a2111i
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 20
                THEN
                  i111a2112i
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 30
                THEN
                  i111a2113i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 10
                THEN
                  i111a2121i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 20
                THEN
                  i111a2122i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 30
                THEN
                  i111a2123i
                ELSE
                  0
              END
            FROM
              i111s
            WHERE
              COALESCE(i111s._dlt,-1)<>1
              AND i111s._vsn = i111s._ltt
              AND i111s.i111_31r1f = i1z5s.i1z5_31r1f
              AND i111s._fst = i1z5s.i1z5i1111f
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s = '${pz.i1z5d1100s}'
          AND i1z5s.i1z5i1111f = ${pz.i1z5i1111f}
      `,
    },
*/
  ]
};

export const grtQryUdtRsvCntI1z5 = (pz: {
  _dmn: _ht.n,
  i1z5_31r1f: _ht.n,
  i1z5i10r1f: _ht.n,
  i1z5d1100sStt: _ht.s,
  i1z5d1100sEnd: _ht.s,
}) => {
  return [
    {
      // 夏時間開始月・終了月の設定（追加したもののみ）
      qry: `
        UPDATE
          i1z5s
        SET
          (i1z5d2100i, i1z5d2200i) = (
            SELECT
              COALESCE(i11ra1100i,0), COALESCE(i11ra1200i,0)
            FROM
              i111s LEFT JOIN i11rs ON i111s.i111i11r1k = i11rs._key
            WHERE
              COALESCE(i111s._dlt,-1)<>1
              AND i111s.i111_31r1f = i1z5s.i1z5_31r1f
              AND i111s._fst = i1z5s.i1z5i1111f
              AND COALESCE(i11rs._dlt,-1)<>1
              AND i11rs._vsn = i11rs._ltt
              AND i11rs.i11r_31r1f = i1z5s.i1z5_31r1f
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s >= '${pz.i1z5d1100sStt}'
          AND i1z5s.i1z5d1100s <= '${pz.i1z5d1100sEnd}'
      `,
    },
    {
      // 夏区分の設定（追加したもののみ）
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5c1100i = (
            SELECT
              CASE
                WHEN
                  SUBSTRING(i1z5d1100s, 6, 2)::NUMERIC >= i1z5d2100i
                  AND SUBSTRING(i1z5d1100s, 6, 2)::NUMERIC <= i1z5d2200i
                THEN
                  1
                ELSE
                  -1
              END
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s >= '${pz.i1z5d1100sStt}'
          AND i1z5s.i1z5d1100s <= '${pz.i1z5d1100sEnd}'
      `,
    },
    {
      // 曜日の設定　＃祝日区分（追加したもののみ）
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5c2100i = (
            SELECT
              CASE
                WHEN
                  EXISTS(
                    SELECT
                      *
                    FROM
                      _601s
                    WHERE
                      COALESCE(_601s._dlt,-1)<>1
                      AND _601s._icn = i1z5s.i1z5d1100s
                  )
                THEN
                  1
                ELSE
                  -1
              END
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s >= '${pz.i1z5d1100sStt}'
          AND i1z5s.i1z5d1100s <= '${pz.i1z5d1100sEnd}'
      `,
    },
    {
      // 曜日の設定　＃曜日区分（追加したもののみ）
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5c3100i = (
            SELECT
              CASE
                WHEN
                  i1z5c2100i = 1 OR DATE_PART('dow', i1z5d1100s::TIMESTAMP)::NUMERIC = 0
                THEN
                  30
                WHEN
                  DATE_PART('dow', i1z5d1100s::TIMESTAMP)::NUMERIC = 6
                THEN
                  20
                ELSE
                  10
              END
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s >= '${pz.i1z5d1100sStt}'
          AND i1z5s.i1z5d1100s <= '${pz.i1z5d1100sEnd}'
      `,
    },
    {
      // 開始・終了時刻の設定
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5d3100i = (
            SELECT
              CASE
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 10
                THEN
                  i111a1111i
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 20
                THEN
                  i111a1112i
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 30
                THEN
                  i111a1113i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 10
                THEN
                  i111a1121i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 20
                THEN
                  i111a1122i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 30
                THEN
                  i111a1123i
                ELSE
                  0
              END
            FROM
              i111s
            WHERE
              COALESCE(i111s._dlt,-1)<>1
              AND i111s._vsn = i111s._ltt
              AND i111s.i111_31r1f = i1z5s.i1z5_31r1f
              AND i111s._fst = i1z5s.i1z5i1111f
          ),
          i1z5d3200i = (
            SELECT
              CASE
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 10
                THEN
                  i111a2111i
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 20
                THEN
                  i111a2112i
                WHEN
                  i1z5c1100i = -1 AND i1z5c3100i = 30
                THEN
                  i111a2113i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 10
                THEN
                  i111a2121i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 20
                THEN
                  i111a2122i
                WHEN
                  i1z5c1100i =  1 AND i1z5c3100i = 30
                THEN
                  i111a2123i
                ELSE
                  0
              END
            FROM
              i111s
            WHERE
              COALESCE(i111s._dlt,-1)<>1
              AND i111s._vsn = i111s._ltt
              AND i111s.i111_31r1f = i1z5s.i1z5_31r1f
              AND i111s._fst = i1z5s.i1z5i1111f
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s >= '${pz.i1z5d1100sStt}'
          AND i1z5s.i1z5d1100s <= '${pz.i1z5d1100sEnd}'
      `,
    },
    {
      // 予約数の更新
      // 集計対象：指定された単体部屋＋指定された複合部屋＋指定された単体部屋を含む複合部屋＋指定された複合部屋に属する単体部屋
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5a1100i = (
            SELECT
              COUNT(*)
            FROM
              i1z1s
              LEFT JOIN i1zrs ON i1z1s.i1z1i1zr1k = i1zrs._key
            WHERE
              COALESCE(i1zrs._dlt,-1) <> 1 AND i1zrs._vsn = i1zrs._ltt
              AND i1zrs.i1zr_31r1f = i1z5s.i1z5_31r1f
              AND i1zrs.i1zrd3100s = i1z5s.i1z5d1100s
              AND i1zrs.i1zrs1100i >= 70
              AND COALESCE(i1z1s._dlt,-1) <> 1
              AND i1z1s.i1z1_31r1f = i1zrs.i1zr_31r1f
              AND (
                (i1z1s.i1z1i10r1f = i1z5s.i1z5i10r1f)
                OR i1z1s.i1z1i10r1f IN (
                  SELECT 
                    _fst 
                  FROM 
                    i10rs 
                  WHERE
                    COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i10r_31r1f = i1z5s.i1z5_31r1f
                    AND _key IN (
                      SELECT
                        i102i10r1k
                      FROM
                        i102s
                      WHERE
                        COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i102_31r1f = i1z5s.i1z5_31r1f
                        AND i102i10r1f = i1z5s.i1z5i10r1f
                    )
                )
                OR i1z1s.i1z1i10r1f IN (
                  SELECT
                    i102i10r1f
                  FROM
                    i102s
                  WHERE
                    COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i102_31r1f = i1z5s.i1z5_31r1f
                    AND i102i10r1k IN (
                      SELECT
                        _key
                      FROM
                        i10rs
                      WHERE
                        COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i10r_31r1f = i1z5s.i1z5_31r1f
                        AND _fst = i1z5s.i1z5i10r1f
                    )
                )
              )
              AND i1z1s.i1z1a1200i > i1z5s.i1z5d3100i
              AND i1z1s.i1z1a1100i < i1z5s.i1z5d3200i
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s >= '${pz.i1z5d1100sStt}'
          AND i1z5s.i1z5d1100s <= '${pz.i1z5d1100sEnd}'
      `,
    },
  ]
};

export const grtQryUdtEryCntI1z5 = (pz: {
  _dmn: _ht.n,
  i1z5_31r1f: _ht.n,
  i1z5i10r1f: _ht.n,
  i1z5d1100sStt: _ht.s,
  i1z5d1100sEnd: _ht.s,
}) => {
  return [
    {
      // エントリ数の更新（予約数が更新されている前提）
      // 集計対象：指定された単体部屋＋指定された複合部屋＋指定された単体部屋を含む複合部屋
      qry: `
        UPDATE
          i1z5s
        SET
          i1z5a2100i = (
            SELECT
              COUNT(*)
            FROM
              i1z1s LEFT JOIN i1zrs ON i1z1s.i1z1i1zr1k = i1zrs._key
            WHERE
              COALESCE(i1zrs._dlt,-1)<>1
              AND i1zrs._vsn = i1zrs._ltt
              AND i1zrs.i1zr_31r1f = i1z5s.i1z5_31r1f
              AND i1zrs.i1zrd3100s = i1z5s.i1z5d1100s
              AND i1zrs.i1zrs1200i >= 70
              AND COALESCE(i1z1s._dlt,-1)<>1
              AND i1z1s.i1z1_31r1f = i1zrs.i1zr_31r1f
              AND (
                (i1z1s.i1z1i10r1f = i1z5s.i1z5i10r1f)
                OR i1z1s.i1z1i10r1f IN (
                  SELECT 
                    _fst 
                  FROM 
                    i10rs 
                  WHERE
                    COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i10r_31r1f = i1z5s.i1z5_31r1f
                    AND _key IN (
                      SELECT
                        i102i10r1k
                      FROM
                        i102s
                      WHERE
                        COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i102_31r1f = i1z5s.i1z5_31r1f
                        AND i102i10r1f = i1z5s.i1z5i10r1f
                    )
                )
                OR i1z1s.i1z1i10r1f IN (
                  SELECT
                    i102i10r1f
                  FROM
                    i102s
                  WHERE
                    COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i102_31r1f = i1z5s.i1z5_31r1f
                    AND i102i10r1k IN (
                      SELECT
                        _key
                      FROM
                        i10rs
                      WHERE
                        COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i10r_31r1f = i1z5s.i1z5_31r1f
                        AND _fst = i1z5s.i1z5i10r1f
                    )
                )
              )
              AND i1z1s.i1z1a1200i > i1z5s.i1z5d3100i
              AND i1z1s.i1z1a1100i < i1z5s.i1z5d3200i
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s._dmn = ${pz._dmn}
          AND i1z5s.i1z5_31r1f = ${pz.i1z5_31r1f}
          AND i1z5s.i1z5i10r1f = ${pz.i1z5i10r1f}
          AND i1z5s.i1z5d1100s >= '${pz.i1z5d1100sStt}'
          AND i1z5s.i1z5d1100s <= '${pz.i1z5d1100sEnd}'
      `,
    },
  ]
};

export const getRsvCntI1z2 = (_i1z2s: _ht.ls) => { // 設備の予約数、時間帯ごとの予約数の最大値を返す
  let _rsvCnt = 0;
  const _rsvCntz = {} as _ht.dz; // 時間帯ごとの設備の予約数
  _i1z2s?.map((_i1z2z: _ht.dz) => {
    _hm.getRng(_i1z2z.i1z2a1200i-1,_i1z2z.i1z2a1100i).map((_hh: _ht.n) => { // 終了時刻を除く
      const _hhKey = String(_hh);
      if (!_rsvCntz[_hhKey]) _rsvCntz[_hhKey] = 0; 
      _rsvCntz[_hhKey] += 1;
      if (_rsvCntz[_hhKey] > _rsvCnt) _rsvCnt = _rsvCntz[_hhKey];
    })
  });
  //_hm.l(`ihm 55: ${_hm.s(_rsvCntz)}`)
  return _rsvCnt;
};

export const $grtRoomIdz = (i10rs: _ht.ls) => { // icm, ism 各々で同一内容を定義していることに留意（ライブラリ配置が異なるため各々で定義）
  let _roomIds = (i10rs ?? []);
  _roomIds = _roomIds.filter((_i10rz: _ht.dz) => _i10rz.i10rt1100i == 10 && _hm.f(_i10rz.i10ra3100s)) // 単体部屋で部屋IDが設定されているもののみ
  _roomIds = _roomIds.map((_i10rz: _ht.dz) => _i10rz.i10ra3100s);
  _roomIds = Array.from(new Set(_roomIds)); // 重複削除
  _roomIds = _roomIds.sort((_id1: _ht.s, _id2: _ht.s) => { // 部屋IDが若い順
      const _id1n = _hm.n(_id1);
      const _id2n = _hm.n(_id2);
      if (_id1n > _id2n) return  1;
      if (_id1n < _id2n) return -1;
      return 0;
    });
  const _dz = {
    prtRoomId: _roomIds.shift(),
    cldRoomId: _roomIds.join(';') ?? '',
  };
  //_hm.l(`ihm 51: ${_hm.s(i10rs)}`);
  //_hm.l(`ihm 52: ${_hm.s(_dz)}`);
  return _dz;
}

/**
  @todo async を外すか、i10rs の取得ロジックを icm.sendEtlAsync から移植するか
 */
export const grtEtlDataAsync = async (pz: { // !!!!! icm と統合用 !!!!!
  i1zrz: _ht.dz, 
  i1z1s: _ht.ls, 
  i1z3z: _ht.dz, 
  i1z4z: _ht.dz, 
  i10rs: _ht.ls, // 部屋（子部屋を含む）
  i15rz: _ht.dz, // 団体種別
  i18rz: _ht.dz, // 団体
  i19rz: _ht.dz, // クライアント
  S91999112: _ht.s,
  S91999122: _ht.s,
}) => {
  // 外部連携を遅延クエリとするため i1zz は事前に登録されている前提、i1zz を削除する場合は削除登録前の i1zz を元に処理する必要があることに留意
  // 本来はサーバー側で事項すべきであるが DB 処理がサーバー側に一元化されていないため 一部 クライアント側で実行
  // クライアント・サーバー両方で動作させるため、DB処理は事前に行われているものとする

  let _yflg =
    pz.i1zrz._dlt == 1 ?// 削除
      "-2"
    : pz.i1zrz.i1zrs1100i == 22 ? // キャンセル済・仮予約
      "-2"
//      : pz.i1zrz.i1zrs1100i == 24 && pz.i1z3z.i1z3s2100i == 1 // キャンセル済・返金あり
    : pz.i1zrz.i1zrs1100i == 24 ? // キャンセル済・返金あり
      "-1"
//      : pz.i1zrz.i1zrs1100i == 26 && pz.i1z3z.i1z3s2100i == -1 // キャンセル済・返金なし
    : pz.i1zrz.i1zrs1100i == 26 ? // キャンセル済・返金なし
      "0"
/*
    : _hm.i(pz.i1zrz.i1zrs1100i, [80, 90]) && pz.i15rz.i15ra7100i == 910 ? // 予約不可
      "3"
    : pz.i1zrz.i1zrs1100i == 80 ? // 仮予約
      "1"
*/
    : pz.i1zrz.i1zrs1100i == 80 && pz.i15rz.i15ra7100i == 910 ? // 予約不可
      "3"
    : pz.i1zrz.i1zrs1100i == 80 && pz.i15rz.i15ra7100i == 110 ? // 一般利用
      "1"
    : pz.i1zrz.i1zrs1100i == 80 && pz.i15rz.i15ra7100i == 920 ? // 個人利用
      "4"
    : pz.i1zrz.i1zrs1100i == 80 && pz.i15rz.i15ra7100i == 930 ? // 老福利用
      "5"
    : pz.i1zrz.i1zrs1100i == 90 && pz.i15rz.i15ra7100i == 910 ? // 予約不可
      "3"
    : pz.i1zrz.i1zrs1100i == 90 && pz.i15rz.i15ra7100i == 110 ? // 一般利用
      "2"
    : pz.i1zrz.i1zrs1100i == 90 && pz.i15rz.i15ra7100i == 920 ? // 個人利用
      "4"
    : pz.i1zrz.i1zrs1100i == 90 && pz.i15rz.i15ra7100i == 930 ? // 老福利用
      "5"
    : ""; // 1: 仮予約, 2: 一般予約, 3: 予約不可, 4: 個人利用, 5: 老福利用, 0: キャンセル返金なし, -1: キャンセル返金あり, -2: 削除
  //_hm.l(`ihm 90: ${pz.i1zrz._dlt}, ${pz.i1zrz.i1zrs1100i}, ${pz.i1z3z.i1z3s2100i}, ${pz.i15rz.i15ra7100i}`)

  //_hm.l(`ihm 91: ${pz.i19rz.i19ra2410i}, ${_yflg}, ${_hm.f(_yflg)}`)
  if ( pz.i19rz.i19ra2410i == 1 && _hm.f(_yflg)) { // 外部連携を使用　かつ yflg が設定されている場合のみ実行
    //_hm.l(`ihm 93: here`)
    let _genFeeTtl = 0; 
    let _ryokinTtl = 0; 
    await _hm.ectSrlAsync(
      pz.i1z1s // 削除処理に対応するため、_i1zz ではなく pz.i1zDz
      .filter((_i1z1z: _ht.dz) =>
        ((_i1z1z._dlt == 1 && !_hm.f(pz.i1zrz.i1zra7100s)) || !_hm.f(_i1z1z)) ? false : true
      )
      .map((_i1z1z: _ht.dz) => async () => {
        const _genFee = 
          _hm.i(_yflg, ["-2", "-1", "1", "3", "4", "5"]) ? // 予約不可、仮予約、キャンセル済・返金あり、個人利用、老福利用、削除
            0
          : (_i1z1z.i1z1m1100i * pz.i1z3z.i1z3m2100i) / (pz.i1z3z.i1z3m1110i ?? pz.i1z3z.i1z3m2100i);
        const _ryokin = _hm.i(_yflg, ["-2", "-1", "1", "3", "4", "5"]) ? // 予約不可、仮予約、キャンセル済・返金あり、個人利用、老福利用、削除
            0
          : _i1z1z.i1z1m1100i - _genFee;
        _genFeeTtl += _genFee;
        _ryokinTtl += _ryokin;
        return true;
      })
    );
    //_hm.l(`icm 1479: ${_genFeeTtl}, ${_ryokinTtl}`);

    const _genmenflg = _hm.i(_yflg, ["-2", "-1", "1", "3", "4", "5"]) // 予約不可、仮予約、キャンセル済・返金あり、個人利用、老福利用、削除
      ? ""
      : pz.i1z3z.i1z3t1100i == 100
      ? "1"
      : pz.i1z3z.i1z3t1100i == 50
      ? "2"
      : pz.i1z3z.i1z3t1100i == 999
      ? "3"
      : ""; // 空欄: なし、1:10割, 2:5割, 3:他
    const _reason = _hm.i(_yflg, ["-2", "-1", "1", "3", "4", "5"]) // 予約不可、仮予約、キャンセル済・返金あり、個人利用、老福利用、削除
      ? ""
      : pz.i1z3z.i1z3t2100i == 10
      ? "A"
      : pz.i1z3z.i1z3t2100i == 20
      ? "B"
      : pz.i1z3z.i1z3t2100i == 30
      ? "C"
      : pz.i1z3z.i1z3t2100i == 40
      ? "D"
      : "";
    const _yuusen = pz.i1zrz.i1zrt1100i == 1 ? "1" : ""; // 1: 優先, 空欄: 対象外
    const _koukai =
      pz.i19rz.i19ra2420i == 10
        ? "0"
        : pz.i19rz.i19ra2420i == 20
        ? "1"
        : pz.i19rz.i19ra2420i == 30
        ? "2"
        : ""; // 0: 非公開, 1: 申込団体を表示, 2: 目的を表示
    const _roomIdz = $grtRoomIdz(pz.i10rs);
    const _s0 = pz.i1z4z.i1z4a1100i ?? 0;
    const _s1 = pz.i1z4z.i1z4a1200i ?? 0;
    const _s2 = _s0 + _s1;
    const _m1 = pz.i1z4z.i1z4a2100i ?? 0;
    const _m2 = pz.i1z4z.i1z4a2200i ?? 0;
    const _m3 = pz.i1z4z.i1z4a2300i ?? 0;
    const _m4 = pz.i1z4z.i1z4a2400i ?? 0;
    const _m5 = pz.i1z4z.i1z4a2500i ?? 0;
    const _m6 = pz.i1z4z.i1z4a2600i ?? 0;
    const _f6 = pz.i1z4z.i1z4a2700i ?? 0;
    const _m7 = pz.i1z4z.i1z4a2800i ?? 0;
    const _f7 = pz.i1z4z.i1z4a2900i ?? 0;
    const _mf = _m1 + _m2 + _m3 + _m4 + _m5 + _m6 + _f6 + _m7 + _f7;
    const _kunai = pz.i1z4z.i1z4a3100i ?? 0;
    const _kugai = pz.i1z4z.i1z4a3200i ?? 0;
    const _shigai = pz.i1z4z.i1z4a3300i ?? 0;
    const _ssk = _kunai + _kugai + _shigai;
    let _title = pz.i1zrz.i1zra4100s;
    const _title2 = _hm.getSrgByByte(_title, 0, 48);
    if (_title != _title2) {
      _title = _title2 + '…';
    }
    _hm.getSrg
    const _iptz = {
      login: pz.S91999112,
      password: pz.S91999122,
      date: pz.i1zrz.i1zrd3100s,
      rsvid: pz.i1zrz.i1zra7100s, // 新規登録時は 0
      start: pz.i1zrz.i1zrd4100i,
      end: pz.i1zrz.i1zrd4200i,
      genFee: _genFeeTtl,
      yflg: _yflg,
      dname: String(pz.i18rz._pfx).replace(/ /g, "%20"),
//      title: pz.i1zrz.i1zra4100s,
      title: _title,
      ryokin: _ryokinTtl,
      feefree: "", // 料金手動入力
      rcvdate: pz.i1z3z.i1z3d2100s,
      genmenflg: _genmenflg,
      reason: _reason,
      bikou: pz.i1zrz._ctn,
      yuusen: _yuusen,
      roomid: _roomIdz.prtRoomId,
      childRoomid: _roomIdz.cldRoomId,
      koukai: _koukai,
      s0: _s0, // 男性
      s1: _s1, // 女性
      s2: _s2, // 合計
      m1: _m1, // 幼児
      m2: _m2, // 小学生
      m3: _m3, // 中学生
      m4: _m4, // 高校生
      m5: _m5, // 大学生
      m6: _m6, // 一般男性
      f6: _f6, // 一般女性
      m7: _m7, // 65歳以上男性
      f7: _f7, // 65歳以上女性
      mf: _mf, // 合計
      kunai: _kunai, // 区内
      kugai: _kugai, // 区外
      shigai: _shigai, // 市内
      ssk: _ssk, // 合計
    };
    //_hm.l(`ihm 201: ${_hm.s(_iptz)}`);
    //_hm.l(`ihm 202: ${encodeURIComponent(_hm.s(_iptz))}`);
    return _iptz; // 外部連携時の文字化けを防ぐ
  }
  else {
    //_hm.l(`ihm 205: here`)
    return undefined;
  }
};

export const udtFee = async (pz: {
  i1zz: _ht.dz,
  i10rs: _ht.ls,
  _601s: _ht.ls,
  i15rz: _ht.dz,
  udtFld?: _ht.s,
}) => {

  const _udtFld = pz.udtFld ?? 'i1z1m1100i'; // 利用料の反映先項目

  pz.i1zz.i1z1s.map((_i1z1z: _ht.dz) => {
    const _i10rz = _hm.getDz(pz.i10rs, _i1z1z.i1z1i10r1f, "_fst");
    //_hm.l(`ihm 1512a: ${_hm.s(_i10rz)}`);
    const _i11rz = _hm.get1(_i10rz?.cldz.i11rs, {});
    //_hm.l(`ihm 1512b: ${_hm.s(_i11rz)}`);
    const _i111s = _i11rz?.cldz?.i111s;
    //_hm.l(`ihm 1512c: ${_hm.s(_i111s)}`);
    const _i111z =
      _i1z1z.i1z1i1111f == ihv.otrz._fst ?
        ihv.otrz
      : _hm.getDz(_i111s, _i1z1z.i1z1i1111f, "_fst");
    //_hm.l(`ihm 1512d: ${_hm.s(_i111z)}`);
/*
    const _i101z = 
      _i1z1z.i1z1i1111f == ihv.otrz._fst ?
        {} 
      : _i111z?.cldz.i101s[0];
*/
/*
    let _i101z = {}
    if (_i1z1z.i1z1i1111f != ihv.otrz._fst) { // その他１時間以外
      _i111z?.cldz.i101s.map((_i101z2: _ht.dz) => {
        if (
          _i1z1z.i1z1d1100s >= _i101z2.i101d1110s &&
          _i1z1z.i1z1d1100s <= _i101z2.i101d1120s
        ) { // 適用開始日以降適用開始日以前の場合
          _i101z = _i101z2
        }
      })
    }
*/
    const _i101z = getI101z({
      i1z1d1100s: _i1z1z.i1z1d1100s,
      i1z1i1111f: _i1z1z.i1z1i1111f,
      i101s: _i111z?.cldz.i101s
    })


    _i1z1z[_udtFld] = getFee({ // 利用料
      i1zrd3100s: _i1z1z.i1z1d1100s, // 利用日
      i10ra2100i: _i10rz?.i10ra2100i, // 単位延長料
      i111_fst: _i1z1z.i1z1i1111f, // 時間帯区分
      i11ra1100i: _i11rz?.i11ra1100i, // 夏時間開始月
      i11ra1200i: _i11rz?.i11ra1200i, // 夏時間終了月
      i101z: _i101z,
      i15ra6100i: pz.i15rz.i15ra6100i, // 時間帯種別
      _601s: pz._601s, // 祝日
    });
    //_hm.l(`ihm 1512f: ${_i1z1z[_udtFld]}`);

  });

  return pz.i1zz;
};
